module.exports = __webpack_public_path__ + "static/media/KOP.ccc4b6b0.jpg";